/**
 * Recursively converts a the keys of an object from UpperCamelCase to lowerCamelCase.
 * Mutates the object in-place.
 */
export function keysToLowerCamelCase<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(item => keysToLowerCamelCase(item)) as T;
  }

  if (obj && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj as Record<string, unknown>).map(([k, v]) => [
        k.charAt(0).toLowerCase() + k.slice(1),
        keysToLowerCamelCase(v),
      ]),
    ) as T;
  }

  return obj;
}
